import { useMutation } from "@tanstack/react-query";
import { AxiosRequestConfig } from "axios";
import axios from "../../../../services/department-viags/config.service";
import { BaseResponse } from "../../../chats/types";

interface RenameFolderSchema {
  key: string;
  newName: string;
}

const BASE_PATH = "/edoc";

const folderApi = {
  rename: async (body: RenameFolderSchema, config?: AxiosRequestConfig) => {
    await axios.post<BaseResponse<unknown>>(`${BASE_PATH}/rename-folder`, body, config);
  },
};

const useRenameFolder = () => {
  return useMutation({
    mutationFn: (body: RenameFolderSchema) => folderApi.rename(body),
  });
};

export default useRenameFolder;
